import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './translations/en.json';
import de from './translations/de.json';
import { LOCAL_STORAGE_PREFIX } from '../services/local-storage.service';
import { environment } from '../../environments/environment';

export const LOCAL_STORAGE_LANGUAGE_KEY = 'language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
    },
    lng: environment.language ? undefined : 'de',
    supportedLngs: environment.language ? ['en', 'de'] : ['de'],
    // supportedLngs: ['de', 'en'],
    fallbackLng: 'de',
    detection: environment.language
      ? {
          order: ['querystring', 'localStorage', 'navigator'],
          lookupQuerystring: 'lang',
          lookupLocalStorage: LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_LANGUAGE_KEY,
        }
      : undefined,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
